import { isProductionMode } from "./Constants"

export const server = isProductionMode ? "https://contech-mailer.azurewebsites.net" : "http://localhost:3333"